export default "__VITE_ASSET__Ci7qJsZh__"